import { SlideYDownTransition,SlideYUpTransition } from 'vue2-transitions'

const Vue2TransitionsConfig = {
  install: function(Vue) {
    Vue.component( "SlideYDownTransition", SlideYDownTransition )
    Vue.component( "SlideYUpTransition", SlideYUpTransition )
  }
}
export default Vue2TransitionsConfig